// extracted by mini-css-extract-plugin
export default {"eventsContainerOverflow":"EventContainerWrapper_eventsContainerOverflow__1kalY"};